import { Button, Spinner } from '@acpaas-ui/react-components';
import { forwardRef } from 'react';
import ReactModal from 'react-modal';

const Modal = forwardRef((props, ref) => {
  const {
    onConfirm,
    className = '',
    onConfirmLabel = 'OK',
    onConfirmIcon,
    onConfirmType = 'success',
    onCancelLabel = 'Annuleren',
    width = 650,
    disableConfirm,
    disableCancel,
    canConfirm = true,
    onClose,
    extraFooterActions,
    isOpen,
    isSubmitting,
    title,
    children
  } = props;
  return (
    <ReactModal
      onRequestClose={onClose}
      className={`spo-m-modal m-modal ${className}`}
      style={{ width: `${width}px` }}
      overlayClassName="m-overlay is-active"
      isOpen={isOpen}
    >
      <div className="spo-m-modal m-modal__content" style={{ width: `${width}px` }}>
        <div className="m-modal__header u-margin-bottom-xs">
          {title}
          <Button className="m-modal__close" icon="ai-close" transparent type="default" onClick={onClose} />
        </div>
        <div className="spo-m-modal__content u-margin-bottom u-margin-top" ref={ref}>
          {children}
        </div>
        <div className="spo-m-modal__footer m-modal__footer">
          {!disableConfirm && (
            <Button
              className={isSubmitting ? 'loading has-icon-right' : ''}
              onClick={onConfirm}
              disabled={!canConfirm || isSubmitting}
              iconRight={isSubmitting ? undefined : onConfirmIcon}
              type={onConfirmType}
            >
              {onConfirmLabel}
              {isSubmitting ? <Spinner /> : ''}
            </Button>
          )}
          {!disableCancel && (
            <Button onClick={onClose} disabled={isSubmitting} negative>
              {onCancelLabel}
            </Button>
          )}
          <div className="spo-m-modal__extra-footer-actions">{extraFooterActions}</div>
        </div>
      </div>
    </ReactModal>
  );
});

export default Modal;
